import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';
import { getLanguage } from 'modules/language/selectors/language';
import getTimezone from 'shared/utils//getTimezone';

import createAction from '../actions';
import * as services from '../services/updateUser';


export const UPDATE_USER = createAsyncAction(createAction('UPDATE_USER'));

export const updateUser = () => (dispatch) => {
  dispatch({ type: UPDATE_USER.pending });

  const timezone = getTimezone();
  const locale = getLanguage();

  const apiCallParams = {
    mutation: services.UPDATE_USER,
    variables: {
      locale,
      timezone,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(() => {
      dispatch({ type: UPDATE_USER.success });
    })
    .catch((err) => dispatch(errorAction(UPDATE_USER.failure, err)));
};
